import React, {Fragment} from "react";
import {Field, Form, Formik} from "formik";
import {useFormModificaBatch} from "./useFormModificaBatch.jsx";
import ModalMsg from "../../../../../components/ModalMsg";

export default function FormModificaBatch({
                                              idBatch,
                                              batch,
                                              formikRef,
                                          }) {

    const {
        initialFormValues,
        validationSchema,
        onSubmitForm,
        show,
        closeModal,
        modalMsg,
    } = useFormModificaBatch({batch})

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <Formik
                enableReinitialize={true}
                initialValues={initialFormValues}
                innerRef={formikRef}
                validationSchema={validationSchema}
                onSubmit={onSubmitForm}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="row g-3 pb-5">
                        <div className="col-md-6">
                            <label htmlFor="codice" className="form-label">Codice*:</label>
                            <Field name="codice" className="form-control" disabled={idBatch}/>
                            {errors.codice && touched.codice ? (
                                <div className="cmms-div-err-form">{errors.codice}</div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="descrizione" className="form-label">Descrizione*:</label>
                            <Field name="descrizione" className="form-control"/>
                            {errors.descrizione && touched.descrizione ? (
                                <div className="cmms-div-err-form">{errors.descrizione}</div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="endpoint" className="form-label">Endpoint*:</label>
                            <Field name="endpoint" className="form-control"/>
                            {errors.endpoint && touched.endpoint ? (
                                <div className="cmms-div-err-form">{errors.endpoint}</div>
                            ) : null}
                        </div>
                    </Form>
                )}
            </Formik>
        </Fragment>
    );
}